// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3bez7","choiceBoxes":"toolbarselects_choiceBoxes__1xZ-k","simpleField":"toolbarselects_simpleField__2o2EM"};